import {GetterTree} from "vuex";
import {PartnersConnectionsState} from "@/store/settings/partners_connections/types";
import {RootState} from "@/store/types";

export const getters: GetterTree<PartnersConnectionsState, RootState> = {
  partnersConnections: (state) => state.partnersConnections,
};